import { Button, Dialog, Inline } from '@etg/wings';
import { css, cx, getTextStyles, mediaQueries } from '@eti/styles';
import { DangerousHtmlContent } from '@eti/components';
import { useTranslation } from '@eti/providers';
import DialogIllustration from './DialogIllustration';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const buttonClass = css`
  @media ${mediaQueries.small.only} {
    width: 100%;
  }
`;
const ReadMoreModal = _ref => {
  let {
    content,
    contentAsMarkup,
    modalConfirmLabel,
    onClose,
    productName,
    show,
    title
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(Dialog, {
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    "data-testid": `${productName}-readMoreModal-open`,
    footer: /*#__PURE__*/_jsx(Inline, {
      align: "end",
      children: /*#__PURE__*/_jsx(Button, {
        className: buttonClass,
        "data-testid": `${productName}-readMoreModal-closeButton`,
        onClick: onClose,
        children: modalConfirmLabel
      })
    }),
    illustration: /*#__PURE__*/_jsx(DialogIllustration, {
      productName: productName
    }),
    isOpen: show,
    onDismiss: onClose,
    title: title,
    children: [/*#__PURE__*/_jsx(DangerousHtmlContent, {
      className: cx('etiModal__content', getTextStyles()),
      content: content,
      "data-testid": `${productName}-dialog-content`
    }), contentAsMarkup]
  });
};
export default ReadMoreModal;